module.exports = __webpack_public_path__ + "static/media/compass.02a60db6.svg";